module.exports = __webpack_public_path__ + "img/upperCaseF.c0313f0f.svg";